﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ActivityUtils
 * @description
 * # ActivityUtils
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ActivityUtils', ['Constants', function (Constants) {

      var utils = {};

      utils.GroupByCategories = function (activities, applyAdditionalInfoAction) {

          activities = activities || [];

          var roomActivities = activities.filter(function (activity) {
              return activity.category === Constants.ActivityCategory.Room;
          });

          var facilityActivities = activities.filter(function (activity) {
              return activity.category === Constants.ActivityCategory.Facility;
          });

          var areaActivities = activities.filter(function (activity) {
              return activity.category === Constants.ActivityCategory.Area;
          });

          var staffActivities = activities.filter(function (activity) {
              return activity.category === Constants.ActivityCategory.Staff;
          });

          return {
              roomActivities: groupRoomActivities(roomActivities, applyAdditionalInfoAction, Constants.ActivityCategory.Room),
              facilityActivities: groupActivities(facilityActivities, applyAdditionalInfoAction, Constants.ActivityCategory.Facility),
              areaActivities: groupActivities(areaActivities, applyAdditionalInfoAction, Constants.ActivityCategory.Area),
              staffActivities: groupActivities(staffActivities, applyAdditionalInfoAction, Constants.ActivityCategory.Staff),

              syncExpandedState: function (oldGroups) {

                  if (oldGroups) {
                      applyExpandedState(this.facilityActivities || [], oldGroups.facilityActivities || []);
                      applyExpandedState(this.areaActivities || [], oldGroups.areaActivities || []);
                      applyExpandedState(this.staffActivities || [], oldGroups.staffActivities || []);

                      (this.roomActivities || []).forEach(function (group) {

                          var oldGroup = oldGroups.roomActivities.firstOrDefault(function (old) {
                              return old.key === group.key;
                          });

                          if (oldGroup) {
                              group.expanded = oldGroup.expanded;

                              group.groupsByLocate.forEach(function (byLocate) {

                                  var oldByLocate = oldGroup.groupsByLocate.firstOrDefault(function (old) {
                                      return old.key === byLocate.key;
                                  });

                                  if (oldByLocate) {
                                      byLocate.expanded = oldByLocate.expanded;
                                  }
                              });
                          }
                      });
                  }
              },

              setExpandedState: function (state) {

                  this.facilityActivities.forEach(function (group) {
                      group.expanded = state;
                  });

                  this.areaActivities.forEach(function (group) {
                      group.expanded = state;
                  });

                  this.staffActivities.forEach(function (group) {
                      group.expanded = state;
                  });


                  this.roomActivities.forEach(function (group) {
                      group.expanded = state;

                      group.groupsByLocate.forEach(function (byLocate) {
                          byLocate.expanded = state;
                      });
                  });
              },

              getAll: function () {
                  return [
                      this.roomActivities,
                      this.facilityActivities,
                      this.areaActivities,
                      this.staffActivities
                  ];
              },

              getActivities: function () {

                  var activities = [];

                  this.getAll().forEach(function (byCategoryGroup) {
                      activities = activities.concat(byCategoryGroup.getActivities());
                  });

                  return activities;
              },

              hasSomeActivities: function () {
                  return this.roomActivities.length > 0 ||
                         this.facilityActivities.length > 0 ||
                         this.areaActivities.length > 0 ||
                         this.staffActivities.length > 0;
              }
          };

      };

      utils.isStaffActivity = function (activity) {
          return activity.category === Constants.ActivityCategory.Staff;
      };

      utils.getActivityIcon = function (activity) {
          var icon = { name: null, color: '#757575' };

          if (activity.activityIcon) {
              var iconArray = activity.activityIcon.split(';');
              if (iconArray[0]) {
                  icon.name = iconArray[0];
              }

              if (iconArray[1]) {
                  icon.color = iconArray[1];
              }
          }

          if (!icon.name) {
              switch (activity.activityTypeId) {
                  case 1:
                      icon.name = 'key';
                      break;
                  case 2:
                      icon.name = 'table';
                      break;
                  case 3:
                      icon.name = 'paw';
                      break;
                  case 4:
                      icon.name = 'user';
                      break;
                  case 5:
                      icon.name = 'building-o';
                      break;
                  case 6:
                      icon.name = 'map-marker';
                      break;
              }
          }
          
      };

      function groupRoomActivities(activities, applyAdditionalInfoAction, category) {

          var byGroupName = activities.groupBy('groupName');

          byGroupName.category = category;

          byGroupName.forEach(function (group) {

              var byLocate = group.items.groupBy('locate');

              group.groupsByLocate = byLocate;
              group.grouppedByLocate = true;

              group.groupsByLocate.forEach(function (byLocateGroup) {
                  byLocateGroup.getTotalDuration = function () {
                      return byLocateGroup.items.sumOf('duration');
                  };
              });

              group.getTotalDuration = function () {

                  var totalDuration = 0;

                  group.groupsByLocate.forEach(function (byLocateGroup) {
                      totalDuration += byLocateGroup.items.sumOf('duration');
                  });

                  return totalDuration;
              };

              group.getActivities = function () {

                  var activities = [];

                  group.groupsByLocate.forEach(function (byLocateGroup) {
                      byLocateGroup.items.forEach(function (activity) {
                          activities.push(activity);
                      });
                  });

                  return activities;
              };

              delete group.items;

              if (applyAdditionalInfoAction) {
                  applyAdditionalInfoAction(group);
              }
          });

          return byGroupName;
      }


      function groupActivities(activities, applyAdditionalInfoAction, category) {

          var byGroupName = activities.groupBy('groupName');

          byGroupName.category = category;

          byGroupName.forEach(function (group) {

              group.getActivities = function () {
                  return group.items;
              };

              group.getTotalDuration = function () {
                  return group.items.sumOf('duration');
              };

              if (applyAdditionalInfoAction) {
                  applyAdditionalInfoAction(group);
              }
          });

          return byGroupName;
      }

      function applyExpandedState(newActivitiesGroup, oldActivitiesGroup) {

          newActivitiesGroup.forEach(function (group) {

              var oldGroup = oldActivitiesGroup.firstOrDefault(function (old) {
                  return old.key === group.key;
              });

              if (oldGroup) {
                  group.expanded = oldGroup.expanded;
              }

          });
      }


      return utils;

  }]);